import { render, staticRenderFns } from "./NewQuestionCard.vue?vue&type=template&id=48b72268&scoped=true"
import script from "./NewQuestionCard.vue?vue&type=script&lang=js"
export * from "./NewQuestionCard.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=48b72268&prod&scoped=true&lang=css&external"
import style1 from "./NewQuestionCard.vue?vue&type=style&index=1&id=48b72268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b72268",
  null
  
)

export default component.exports